import React from 'react';
import { Helmet } from "react-helmet";
import './orgs.style';
import { Orgs } from './orgs';

export class Orgs_Component extends React.Component {
    constructor( props ) {
        super();
    }

    render() {
        return (
            <>
                <Helmet>
                    <title>{`Все клиники Нижегородской области: контакты, время работы, услуги, цены, локация, специалисты, отзывы - Медицинский портал Нижегородской области: информация о врачах и учреждениях здравоохранения - Медицинский портал Нижегородской области: информация о врачах и учреждениях здравоохранения`}</title>
                    <meta property='og:title' content={`Все клиники Нижегородской области: контакты, время работы, услуги, цены, локация, специалисты, отзывы - Медицинский портал Нижегородской области: информация о врачах и учреждениях здравоохранения - Медицинский портал Нижегородской области: информация о врачах и учреждениях здравоохранения`} />
                    <meta name="description" content={`Все частные медицинские клиники (стоматологии, дерматологии, ЛОР клиники, офтальмологические клиники, онкологические центры, психиатрические центры и клиники и тд) диагностические центры, лаборатории, санатории, а также государственные больницы и поликлиники, областные и районные центры Нижнего Новгорода, Дзержинска, Арзамаса и других городов Нижегородской области на медицинском портале 52c.ru`} />
                    <meta name="og:description" content={`Все частные медицинские клиники (стоматологии, дерматологии, ЛОР клиники, офтальмологические клиники, онкологические центры, психиатрические центры и клиники и тд) диагностические центры, лаборатории, санатории, а также государственные больницы и поликлиники, областные и районные центры Нижнего Новгорода, Дзержинска, Арзамаса и других городов Нижегородской области на медицинском портале 52c.ru`} />
                </Helmet>
                <Orgs />
            </>   
        );
    }
}